<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="sales"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    :itemClass="itemClasses"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
  >

    <template slot="link1" slot-scope="{ item }">
      <v-tooltip top v-if="item.nfes.length > 0">
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            link
            v-on="{ ...tooltip }"
            :to= "'/app/outbound_nfes?saleId=' + item.id"
          >
            <v-badge
              :content="item.nfes.length"
              :value="item.nfes.length"
              color="green"
              overlap
              offset-x="8"
              offset-y="8"
            >
              <v-icon>mdi-file-certificate</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>Visualizar NFP-e{{item.nfes.length > 1 ? 's' : ''}}</span>
      </v-tooltip>

      <v-tooltip top v-if="item.nfces.length > 0">
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            link
            v-on="{ ...tooltip }"
            :to= "'/app/outbound_nfces?saleId=' + item.id"
          >
            <v-badge
              :content="item.nfces.length"
              :value="item.nfces.length"
              color="green"
              overlap
              offset-x="8"
              offset-y="8"
            >
              <v-icon>mdi-receipt</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>Visualizar NFC-e{{item.nfces.length > 1 ? 's' : ''}}</span>
      </v-tooltip>
    </template>

    <template slot="filterText1">
        <v-card style="margin: 10px;">
          <v-text-field
            style="padding: 16px 16px;"
            v-model="productNames"
            label="Filtrar vendas por nome do item"
            >
          </v-text-field>
        </v-card>
    </template>


    <template slot="new">
      <v-dialog
        :scrollable="true"
        persistent
        :fullscreen="true"
        v-if="$vuetify.breakpoint.smAndDown"
        v-model="dialogModel"
        @keydown.esc="dialogCancelAction"
      >
        <v-overlay :value="pageLoading">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <div v-if="loading">
          <v-skeleton-loader
            class="mx-auto d-none d-sm-block"
            type="article, actions"
          ></v-skeleton-loader>

          <v-skeleton-loader
            class="mx-auto d-sm-none"
            type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
          ></v-skeleton-loader>
        </div>
        <v-card v-else>
          <v-card-title>
            <span class="h4">Criar</span>
            <v-spacer></v-spacer>
              <v-btn
                text
                icon
                title="Cancelar"
                class="my-2"
                @click="dialogCancelAction"
              >
                <v-icon right dark>mdi-close-circle</v-icon>
              </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text id="dialogBody">

            <v-list
              :flat="false"
              :dense="false"
              class="mt-5"
            >
              <v-list-item-group
                :multiple="false"
                color="success"
              >
                
                <v-divider
                  key="divider-1"
                />
                <v-list-item
                  key="list-item-1"
                  @click="newOpenAction"
                  :two-line="false"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-handshake</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span class="title">Nova Venda</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider
                  key="divider-2"
                />
                <v-list-item
                  key="list-item-2"
                  @click="multiSalesOpenAction"
                  :two-line="false"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-bank-plus</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span class="title">Fatura de multiplas vendas</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>                
                
                <v-divider
                  key="divider-last"
                />
                
              </v-list-item-group>
            </v-list>

            <New              
              @entry-created="entryCreated"
              @entry-canceled="loadServerEntries()"
              :modelNameSingular="modelNameSingular"
              :useModelInsteadOfButton="true"
              ref="newRef"
            />

            <!-- <MultiSales
              @entry-created="entryCreated"
              @entry-canceled="loadServerEntries()"
              modelNameSingular="Fatura"
              :useModelInsteadOfButton="true"
              ref="multiSalesRef"
            /> -->

          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn class="my-2" @click="dialogCancelAction">
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
        <template v-slot:activator="{ on: dialog }" @open-dialog="dialogOpenAction">
          <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                color="primary"
                class="ma-1 d-none d-md-flex"
                v-on="{ ...tooltip, ...dialog }"
                @click="dialogOpenAction"
                :disabled="false">
                  Adicionar Venda
                <v-icon right dark>mdi-plus</v-icon>
              </v-btn>

              <v-btn
                class="d-md-none"
                color="primary"
                absolute
                right
                fab
                v-on="{ ...dialog }"
                @click="dialogOpenAction"
                :disabled="false"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>

            </template>
            <span>Criar Venda</span>
          </v-tooltip>
        </template>
      </v-dialog>      

      <New
        v-if="$vuetify.breakpoint.mdAndUp"
        @entry-created="entryCreated"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
      />

      <!-- <MultiSales
        v-if="$vuetify.breakpoint.mdAndUp"
        @entry-created="entryCreated"
        @entry-canceled="loadServerEntries()"
        modelNameSingular="Fatura"
      /> -->
    </template>    

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        v-if="item.statusKey == 'opened'"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :readOnly="item.statusKey != 'opened'"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <!-- emitir NFe -->
    <template v-if="$can('update', $router.currentRoute.name) && item.canIssueNfe && item.fiscalDocumentType == 'NFPe'" slot="action1" slot-scope="{ item }">
      <NfpeNew 
        :cashFlow="item"
        modelNameSingular="NFP-e">
      </NfpeNew>
    </template>

    <!-- reemitir NFe -->
    <template v-if="$can('update', $router.currentRoute.name) && item.canReissueNfe && item.fiscalDocumentType == 'NFPe'" slot="action2" slot-scope="{ item }">
      <NfpeEdit 
        :entry="item.nfes[0]"
        modelNameSingular="NFP-e">
      </NfpeEdit>
    </template>

    <!-- emitir NFCe -->
    <template v-if="$can('update', $router.currentRoute.name) && item.canIssueNfe && item.fiscalDocumentType == 'NFCe'" slot="action3" slot-scope="{ item }">
      <NfceNew 
        :cashFlow="item"
        modelNameSingular="NFC-e">
      </NfceNew>
    </template>

    <!-- reemitir NFCe -->
    <template v-if="$can('update', $router.currentRoute.name) && item.canReissueNfe && item.fiscalDocumentType == 'NFCe'" slot="action4" slot-scope="{ item }">
      <NfceEdit 
        :entry="item.nfces[0]"
        modelNameSingular="NFC-e">
      </NfceEdit>
    </template>  
    
    <template slot="action5" slot-scope="{ item }" v-if="item.statusKey == 'opened' && item.nfes && item.nfes.length>0">
      <ClosePerformanceSale
        :entry="item"
        @entry-destroyed="entryDeleted"
        :readOnly="item.statusKey != 'opened'"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="action6" slot-scope="{ item }">
      <NewCashOutflow
        v-if="item.nfes && item.nfes.length > 0"
        :extraData2="item"
        @entry-destroyed="entryDeleted"
        :readOnly="false"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
        :inlineAddButton="true"
        addButtonIcon="mdi-truck-outline"
      />
    </template>

    <template slot="action7" slot-scope="{ item }" v-if="item.statusKey == 'billed' && item.nfes && item.nfes.length>0">
      <ReopenSale
        :entry="item"
        @entry-destroyed="entryDeleted"
        :readOnly="item.statusKey != 'billed'"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="action8" slot-scope="{ item }" v-if="item.statusKey == 'opened' && loggedUser && loggedUser.accountId == 46">
      <CloseSale
        :entry="item"
        @entry-destroyed="entryDeleted"
        :readOnly="item.statusKey != 'opened'"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
      />
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";
import NfpeNew from "@models/fiscal_documents/outbounds/nfes/nfpes/new.vue";
import NfpeEdit from "@models/fiscal_documents/outbounds/nfes/nfpes/edit.vue";
import NfceNew from "@models/fiscal_documents/outbounds/nfes/nfces/new.vue";
import NfceEdit from "@models/fiscal_documents/outbounds/nfes/nfces/edit.vue";
import MultiSales from "@models/sales/nfpe_multi_sales/new.vue";
import ClosePerformanceSale from './close_performance_sale.vue';
import CloseSale from './close_sale.vue';
import ReopenSale from './reopen_sale.vue';
import NewCashOutflow from '@models/cash_flows/cash_outflows/new.vue';


export default {
  data() {
    return {
      sales: [],
      loggedUser: null,
      loading: true,
      dialogModel: false,
      pageLoading: false,
      totalItems: 0,
      productNames: null,
      tableHeaders: [
        { text: "Nº da Venda", align: "left", sortable: true, value: "code"},
        { text: "Cliente", align: "left", sortable: true, value: "customerName"},
        { text: "Valor", align: "left", sortable: false, value: "totalPrice"},
        { text: "Recebido", align: "left", sortable: false, value: "totalPaidAmount"},
        { text: "Pendente", align: "left", sortable: false, value: "unpaidAmount"},
        { text: "Data da Venda", align: "left", sortable: true, value: "date" },
        { text: "Faturamento", align: "left", sortable: true, value: "billDate" },
        { text: "Doc. Fiscal", align: "left", sortable: true, value: "fiscalDocumentType" },
        { text: "CFOP", align: "left", sortable: true, value: "cfopCode" },
        { text: "Status", align: "left", sortable: true, value: "saleStatus" },
        // { text: "Entrega", align: "left", sortable: true, value: "deliveryDate" },
        { text: "NF-e", align: "left", sortable: false, value: "link" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'billDate', mask: 'date' }, 
        { field: 'deliveryDate', mask: 'date' },
        { field: 'date', mask: 'date' }, 
        { field: 'totalPrice', mask: 'currency' }, 
        { field: 'totalPaidAmount', mask: 'currency' }, 
        { field: 'unpaidAmount', mask: 'currency' }, 
        { field: 'saleStatus', mask: 'status_color', colorField: 'statusColor' }, 
      ],
      infoHeaders: [
        { field: 'totalPrice', info: 'Valor da venda a receber (capital)' },
        { field: 'totalPaidAmount', info: 'Valor já recebido da venda incluindo juros, multas e descontos' },
        { field: 'unpaidAmount', info: 'Valor restante a ser recebido (capital)' },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [],
      typeOperators: [],
      serverFields: [],
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Venda"
    },
    modelNamePlural: {
      type: String,
      default: "Vendas"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
    NfpeNew: NfpeNew,
    NfpeEdit: NfpeEdit,
    NfceNew: NfceNew,
    NfceEdit: NfceEdit,
    MultiSales: MultiSales,
    ClosePerformanceSale: ClosePerformanceSale,
    CloseSale: CloseSale,
    ReopenSale: ReopenSale,
    NewCashOutflow: NewCashOutflow,
  },
  created() {
    this.getCurrentUser(user => {
      this.loggedUser = user;
    });
    // this.loadServerEntries();
    // let data = this.$root.$data
    // this.getCurrentUser(user => {
    //   console.log("feito", user);
    // });
    // setTimeout(function(){
    //   console.log("Index sale", data.localUser);
    // }, 1000)
  },
  mounted() { 
    
  },
  watch: {
    "productNames": function(newSearch) {
      if (this.productNames && this.productNames.length > 0) {
        if (newSearch.length >= 3) {
          if(this.timer){
            clearTimeout(this.timer);
          }
          this.timer = setTimeout( ()=> {
            // console.log("newSearch", newSearch); 
            this.loadServerEntries();
          }, 2000);
        }
      }else{
        if(this.timer){
          clearTimeout(this.timer);
        }
        this.loadServerEntries();
      }
    },
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      let route = this.$route;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_SALES,
          variables: {
            input: {
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.value),
              filters: this.filters,
              customFilters: {product_names: this.productNames},
            },
            nfeId: route.query.nfeId ? route.query.nfeId : null
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // console.log("response", response);
          this.sales = response.data.accountContext.salesIndex.saleViewIndexFilters;
          // console.log(this.sales);

          this.totalItems = response.data.accountContext.salesIndex.count;
          this.typeOperators = response.data.accountContext.salesIndex.typeOperators;
          this.serverFields = response.data.accountContext.salesIndex.serverFields;
          // console.log("All salesIndex", this.sales, this.totalItems);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
    itemClasses: function(item) {
      if (item.statusKey == "opened") {
        return "opened_item";
      } else if (item.unpaidAmount > 0) {
        return "pending_item";
      }
    },
    multiSalesOpenAction: function() {
      // console.log("flag", $vuetify.breakpoint.mdAndUp);
      if (this.$refs.multiSalesRef) {
        if (this.$refs.multiSalesRef.$refs.baseNew) {
          this.$refs.multiSalesRef.$refs.baseNew.openAction();
          this.dialogCancelAction();
        }
      }
    },
    newOpenAction: function() {
      if (this.$refs.newRef) {
        if (this.$refs.newRef.$refs.baseNew) {
          this.$refs.newRef.$refs.baseNew.openAction();
          this.dialogCancelAction();
        }
      }
    },
    dialogOpenAction: function() {
      // this.dialogModel = true;
      // console.log("dialogOpenAction", this.dialogModel);
    },
    dialogCancelAction: function() {
      // console.log("dialogCancelAction");
      this.dialogModel = false;
      console.log("dialogOpenAction", this.dialogModel);
    },
  }
};

const LOAD_ALL_SALES = gql `
  query($input: IndexInputObject!, $nfeId: ID) {
    accountContext {
      salesIndex(input: $input, nfeId: $nfeId) {
        count
        saleViewIndexFilters {
          id
          code
          date
          status
          statusKey
          saleStatus
          cfopCode
          statusColor
          canClosePerformance
          customerId
          customerName
          nfes {
            id
            status
            performance
          }
          nfces {
            id
            status
          }
          billDate
          estimatedDeliveryDate
          orderValidity
          totalPrice
          paidAmount
          totalCarriageValue
          totalPaidAmount
          fiscalDocumentType
          unpaidAmount
          canIssueNfe
          canReissueNfe
          canBeDeleted
          undeletabilityReasons
        }
        typeOperators
        serverFields
      }
    }
  }
`;

</script>

<style scoped>
  ::v-deep .pending_item {
    color: blue;
  }

  ::v-deep .opened_item {
    color: rgb(134, 134, 134);
    font-style: italic;
  }
</style>
